function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "instagram_inline_svg__hzgkex2apa",
  d: "M0 0h14v14H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(5 5.92)"
}, React.createElement("mask", {
  id: "instagram_inline_svg__lqp7fryrtb",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#instagram_inline_svg__hzgkex2apa"
})), React.createElement("path", {
  d: "M4.112.05c1.157-.067 4.62-.067 5.775 0 1.121.055 2.114.311 2.933 1.13.822.818 1.078 1.812 1.13 2.933.067 1.156.067 4.617 0 5.773-.055 1.122-.311 2.115-1.13 2.934-.819.821-1.812 1.077-2.933 1.131-1.155.065-4.619.065-5.775 0-1.12-.057-2.11-.313-2.933-1.13C.36 12 .103 11.007.05 9.885c-.066-1.156-.066-4.62 0-5.776.056-1.12.31-2.115 1.13-2.933C2.002.358 2.994.102 4.112.05m2.89 3.361A3.584 3.584 0 003.412 7a3.583 3.583 0 003.59 3.59A3.583 3.583 0 0010.59 7 3.584 3.584 0 007 3.41m3.735-.984a.838.838 0 10.002 1.675.838.838 0 00-.002-1.675",
  fill: "#0052D2",
  mask: "url(#instagram_inline_svg__lqp7fryrtb)"
})), React.createElement("path", {
  d: "M12.002 10.586a2.336 2.336 0 012.332 2.334 2.337 2.337 0 01-2.332 2.333 2.337 2.337 0 01-2.334-2.333 2.336 2.336 0 012.334-2.334",
  fill: "#47AAFF"
}));

function SvgInstagraminline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _ref, _ref2);
}

export default SvgInstagraminline;